import { createRoute } from "@tanstack/solid-router";
import { AchievementsPage } from "@/features/gamification/components/achievements-page";
import { appRoute } from "./route";

/**
 * GAMIFICATION-CORE (UI) — "Logros": racha de lectura (destacada), XP/nivel y
 * badges de constancia, derivados de las anotaciones locales (proyección pura).
 * Opt-in y no punitivo; ligas privadas por defecto.
 */
export const achievementsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/achievements",
  component: AchievementsPage,
});
